import { DynamicModuleDefinition } from "../types";

export function defineModule<T>(
    options: DynamicModuleDefinition<T>
): DynamicModuleDefinition<T> {
    return options;
}
